import axios from './utils/axios';

export var requestInvite = function requestInvite(email) {
  var url = '/invitations/' + email;
  return axios.post(url, {}, { withCredentials: false });
};
//# sourceMappingURL=invitations.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/invitations.js
// module id = 1079
// module chunks = 0